// @flow

import _ from 'lodash/fp';
import {UnauthorizedError, ValidationError} from './errors';
import {logout} from '../actions/auth';
import {addNotification} from '../actions/notification';
import type {Dispatch} from 'redux';

const handleError = (dispatch: Dispatch<*>, expectBody?: boolean = true) => async (response: Response): Promise<any> => {
  const contentType = response.headers.get('content-type');
  let body: ?any = null;
  const isError = !response.ok;
  if (contentType && contentType.indexOf('application/json') !== -1) {
    body = await response.json();
  } else if (isError && contentType && contentType.indexOf('text/plain') !== -1) {
    body = await response.text();
  } else if (expectBody && response.ok) {
    throw new ValidationError('Ogiltigt svar från servern', [response]);
  }
  if (isError) {
    const message = !!body && typeof body === 'object'
      ? _.getOr(body, 'message', body)
      : body;
    dispatch(addNotification(message, 'error'));
    if (response.status === 401) {
      dispatch(logout());
      throw new UnauthorizedError(message);
    } else if (response.status === 400) {
      const errors = !!body && typeof body === 'object'
        ? _.getOr([], 'errors', body)
        : [];
      throw new ValidationError(message, errors);
    } else {
      throw new Error(message);
    }
  }

  return body;
};

export const handleIEBugs = (dispatch: Dispatch<*>) => (reason: any): any => {
  if (reason && reason.name === 'TypeMismatchError') {
    dispatch(logout());
    throw new UnauthorizedError('Obehörig åtkomst');
  } else if (reason && reason instanceof Error) {
    throw reason;
  } else {
    throw new Error(reason);
  }
};

export default handleError;



// WEBPACK FOOTER //
// ./src/helpers/errorHandler.js